import { useEffect, useState } from "react";

import { type WebLensLogoMeasurement, measureWebLensLogo } from "../utils/measureWebLensLogo";

/**
 * Measures the picked icon's pixel dimensions for the dimension gate. The rail's dimension row,
 * the push button and runPushClientPreChecks all read this one value, so they can never disagree
 * about the same file. Null while nothing is picked, while the read is in flight, and for files
 * the parser bails on (not a PNG, truncated) — in every null case the gate stays open and the
 * server-side conversion is the verdict.
 */
export const useWebLensLogoMeasurement = (logo: File | null): WebLensLogoMeasurement | null => {
    const [measurement, setMeasurement] = useState<WebLensLogoMeasurement | null>(null);

    useEffect(() => {
        setMeasurement(null);
        if (!logo) {
            return;
        }
        let stale = false;
        void measureWebLensLogo(logo).then((measured) => {
            if (!stale) {
                setMeasurement(measured);
            }
        });
        return () => {
            stale = true;
        };
    }, [logo]);

    return measurement;
};
